// Debouncing - to prevent function to fire multiple times within a timeframe
// useLeading means fire function first, debounce after, the opposite is trailing

export function useDebounce(
  customFunction: (...args: unknown[]) => unknown,
  delay: number = 500,
  useLeading = false,
) {
  let timeOutId: number | null;
  let tempUseLeading = useLeading; // used to prevent eslint[no-param-reassign]

  const debouncedFunction = (...args: unknown[]) => {
    if (timeOutId) clearTimeout(timeOutId);

    if (tempUseLeading && !timeOutId) {
      customFunction(...args);
      tempUseLeading = true;
    } else {
      tempUseLeading = false;
    }

    timeOutId = window.setTimeout(() => {
      if (!tempUseLeading) {
        customFunction(...args);
      }

      timeOutId = null;
    }, delay);
  };

  return debouncedFunction;
}
